import { useAllFundNames, useProjectStatus } from "../../lib/hooks";
import styles from "./../../styles/charts/chartStyle.module.css";
import { useEffect, useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  Modal,
  Box,
  Rating,
} from "@mui/material";
import BarChart from "./protoCharts/BarChart";
// @ts-ignore
import * as _ from "underscore";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "./twitter/TwitterWordCloud";
import CustomSlider from "../common/customSlider";
import { underscoreToCap } from "../../lib/util";

interface ProjectStatusProps {
  xlabel?: string;
  ylabel: string;
  single_fund: boolean;
  fund_id: string | number;
  popped?: boolean;
  desc: string;
}

const max: number = 100000;

const ProjectStatus = (props: ProjectStatusProps) => {
  const {
    allFundNames,
    loading: fundNameLoading,
    error: fundNameError,
  } = useAllFundNames();

  const [fund, setFund] = useState<any>({ fund_id: 4, fund_name: "Fund4" });
  // const [allFunds, setAllFunds] = useState<any[]>([]);
  const [rating, setRating] = useState<number>(1);
  const [requestedAmount, setRequestedAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const [distributedAmount, setDistributedAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const [status, setSatus] = useState<string>("project_on_track");

  useEffect(() => {
    if (!fundNameLoading && fundNameError === null) {
      setFund(allFundNames.slice(0)[0]);
    }
    //eslint-disable-next-line
  }, [fundNameLoading]);

  const { projectStatusData, loading, error } = useProjectStatus({
    status_column: status,
    fund_id: props.single_fund ? fund.fund_id : "All",
    rating: rating,
    amount_requested: requestedAmount,
    amount_distributed: distributedAmount,
  });

  const handleFundChange = (event: any) => {
    const id = event.target.value;
    let fundObj = allFundNames.filter((funds) => funds.fund_id == id);
    console.log(fundObj);
    setFund(fundObj[0]);
  };

  //  get legend
  let legend: string[] = [];
  if (!loading && !error) {
    projectStatusData[0].items.forEach((item: any) => {
      legend.push(item.project_status);
    });
  }

  // get data and category
  let chartData1: any[] = [];
  let categories: any[] = [];

  if (!loading && !error) {
    projectStatusData.forEach((item: any) => {
      let data: any[] = [];
      props.single_fund
        ? categories.push(item.challenge_name)
        : categories.push(item.fund_name);

      item.items.forEach((count: any) => {
        data.push(count.count);
      });
      chartData1.push(data);
    });
  }

  let chartData2 = _.zip(...chartData1);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => {
    return (
      <>
        <Paper elevation={3} className={styles.chartContainer}>
          <div className="horizontalCenter">
            <Typography className={styles.chartHeader}>
              {props.single_fund
                ? `Project Status for ${fund.fund_name}`
                : `Project Status for All Funds`}
            </Typography>
          </div>
          {showMaxButton && (
            <>
              <div className="horizontalCenter">
                <div className={styles.selectOptionRow}>
                  <div className="horizontalCenter">
                    <Typography
                      component="legend"
                      className={styles.flexLabelFont}
                    >
                      Rating:
                    </Typography>
                    <Rating
                      name="simple-controlled"
                      value={rating ? rating : 0}
                      onChange={(event, newVal) => setRating(newVal as number)}
                    />
                  </div>
                  {props.single_fund && (
                    <FormControl size="small">
                      <InputLabel className={styles.flexSelectFont}>
                        Fund
                      </InputLabel>
                      <Select
                        label="Fund"
                        onChange={handleFundChange}
                        value={fund ? fund.fund_id : ""}
                        size="small"
                        className={styles.flexSelectFont}
                      >
                        {allFundNames.map((single_fund: any) => (
                          <MenuItem
                            style={{ fontSize: "14px" }}
                            value={single_fund.fund_id}
                            key={single_fund.fund_id}
                          >
                            {single_fund.fund_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  <FormControl size="small">
                    <InputLabel className={styles.flexSelectFont}>
                      Group By
                    </InputLabel>
                    <Select
                      label="Grpup By"
                      onChange={(event: any) => setSatus(event.target.value)}
                      defaultValue="project_on_track"
                      size="small"
                      className={styles.flexSelectFont}
                    >
                      {[
                        "project_on_track",
                        "project_completed",
                        "project_status",
                      ].map((status: any) => (
                        <MenuItem
                          style={{ fontSize: "14px" }}
                          value={status}
                          key={`${status}`}
                        >
                          {underscoreToCap(status)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <CustomSlider
                min={0}
                max={max}
                label="Amount Requested"
                onChange={(val: number[]) =>
                  setRequestedAmount("[" + val.join(",") + "]")
                }
              />
              <CustomSlider
                min={0}
                max={max}
                label="Amount Distributed"
                onChange={(val: number[]) =>
                  setDistributedAmount("[" + val.join(",") + "]")
                }
              />
            </>
          )}
          {error && (
            <Typography sx={{ pb: "150px", pt: "150px", alignSelf: "center" }}>
              No data for your selection, please try again.
            </Typography>
          )}
          {!error && (
            <div style={{ width: "100%" }}>
              <BarChart
                loading={loading}
                numberOfColumns={3}
                chartData={chartData2}
                legend={legend}
                // xLabel={props.xlabel}
                yLabel={props.ylabel}
                categories={categories}
              />
            </div>
          )}
          {getChartBottomIcons(showMaxButton, setOpen)}
          {getChartInfoIcons(props.desc)}
        </Paper>
      </>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
};

export default ProjectStatus;
